import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "103",
  "slug": "best-free-geography-games-2026",
  "title": "Free Geography Games: Choose by the Kind of Puzzle",
  "excerpt": "A short list of map quizzes, street views, video clues, and satellite rounds, with official links and access limits to check.",
  "date": "2026-03-14",
  "category": "Community",
  "image": "https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Choose a geography game by what you want to inspect: a map outline, a street scene, a video, or an overhead landscape. This list groups games by that task. It is not a measured ranking of learning outcomes or popularity."
    },
    {
      "type": "heading",
      "text": "Map quizzes and outlines"
    },
    {
      "type": "paragraph",
      "text": "Seterra's website quizzes are free with ads. Worldle offers a free daily silhouette puzzle; access to its archive is a separate premium feature. Start with map quizzes when your aim is recalling names and locations, or an outline puzzle when you want one small daily task."
    },
    {
      "type": "heading",
      "text": "Street scenes and video"
    },
    {
      "type": "paragraph",
      "text": "WorldGuessr and OpenGuessr offer free street-view guessing. City Guesser uses video. These formats provide different kinds of detail, so inspect a sample round rather than assuming their coverage or difficulty is identical."
    },
    {
      "type": "paragraph",
      "text": "GeoGuessr also has an official free-play route, alongside subscriptions. Calling it simply paywalled would leave out that option."
    },
    {
      "type": "heading",
      "text": "Satellite landscapes"
    },
    {
      "type": "paragraph",
      "text": "EarthGuessr asks you to locate overhead imagery. Look for terrain and coastline shapes rather than street signs. Standard play, daily challenges, streaks, and multiplayer are available in the application; multiplayer uses a signed-in account."
    },
    {
      "type": "paragraph",
      "text": "EarthGuessr publishes this guide. Its inclusion reflects the satellite format, not an independent award or a claim that it is the best choice for everyone."
    },
    {
      "type": "heading",
      "text": "Check what free includes"
    },
    {
      "type": "paragraph",
      "text": "Before organising a group session, open the joining flow on a second device. Check ads, account requirements, and the mode you plan to play. A free solo round does not establish that every group feature is free or that a service can host an audience of any size."
    },
    {
      "type": "paragraph",
      "text": "The links below are the product references checked on 14 September 2026. Use the plan shown by each service for current access and billing terms."
    }
  ],
  "sources": [
    {
      "title": "GeoGuessr support: free access to Seterra",
      "url": "https://www.geoguessr.support/support/solutions/articles/206000056685-is-the-seterra-geography-website-free-to-use-"
    },
    {
      "title": "Worldle: rules and free daily puzzle",
      "url": "https://worldle.teuteuf.fr/"
    },
    {
      "title": "WorldGuessr: free street-view game",
      "url": "https://www.worldguessr.com/"
    },
    {
      "title": "OpenGuessr: game and access",
      "url": "https://openguessr.com/"
    },
    {
      "title": "City Guesser: video-based location games",
      "url": "https://virtualvacation.us/guess"
    },
    {
      "title": "GeoGuessr: free-play entry point",
      "url": "https://www.geoguessr.com/free"
    }
  ],
  "relatedSlugs": [
    "geoguessr-alternatives-free",
    "best-daily-geography-games-wordle-style"
  ]
};
